<template>
  <div class="page_tax">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="98px">
            <el-form-item label="税款所属期" size="small">
              <el-date-picker v-model="listQuery.ReportingMonth" type="month" value-format="yyyy-MM" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="申报公司" size="small">
              <el-select v-model="listQuery.PayrollCompany" placeholder="" value-key="Projectid" size="small" style="width: 180px;" clearable filterable>
                <el-option v-for="(item, index) in legList" :key="index" :label="item.name" :value="item.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="项目名称" size="small">
              <el-select v-model="listQuery.projectId" placeholder="" value-key="Projectid" size="small" style="width: 180px;" clearable filterable>
                <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.Projectid"></el-option>
              </el-select>
            </el-form-item>

          </el-form>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="98px">
          <div>
            <el-form-item label="发生开始时间" size="small" label-width="126px">
              <el-date-picker v-model="listQuery.name" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="发生结束时间" size="small">
              <el-date-picker v-model="listQuery.name2" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="税号" size="small">
              <el-input v-model="listQuery.PayrollCompany" style="width:180px" size="small"></el-input>
            </el-form-item>
          </div>
          <div style="margin-top:5px">
            <el-form-item label="证件号码" size="small" label-width="127px">
              <el-input v-model="listQuery.cardId" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="姓名" size="small">
              <el-input v-model="listQuery.EmployeeName" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="手机号" size="small">
              <el-input v-model="listQuery.name" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="客服" size="small">
              <el-select v-model="listQuery.CustomerServiceId" placeholder="" clearable size="small" style="width: 180px;" filterable>
                <el-option v-for="(item,index) in customerList" :key="index" :label="item.Username" :value="item.Userid"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs2 flex">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>薪酬</el-breadcrumb-item>
          <el-breadcrumb-item>个税</el-breadcrumb-item>
          <el-breadcrumb-item>所得明细</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
          <el-tab-pane label="报税确认" name="待确认" v-if="checkPermission(['incomeDtl_TBC'], permissionLists)"></el-tab-pane>
          <el-tab-pane label="报税信息维护" name="所得明细" v-if="checkPermission(['incomeDtl_incomeDtl'], permissionLists)"></el-tab-pane>
          <el-tab-pane label="个税草稿" name="个税草稿" v-if="checkPermission(['incomeDtl_tax'], permissionLists)"></el-tab-pane>
          <el-tab-pane label="待申报" name="待申报" v-if="checkPermission(['incomeDtl_declared'], permissionLists)"></el-tab-pane>
          <el-tab-pane label="申报中" name="申报中" v-if="checkPermission(['incomeDtl_declareding'], permissionLists)"></el-tab-pane>
          <el-tab-pane label="申报成功" name="申报成功" v-if="checkPermission(['incomeDtl_declaredSuccess'], permissionLists)"></el-tab-pane>
          <el-tab-pane label="申报失败" name="申报失败" v-if="checkPermission(['incomeDtl_declaredFail'], permissionLists)"></el-tab-pane>
          <el-tab-pane label="扣除信息" name="扣除信息" v-if="checkPermission(['incomeDtl_deduction'], permissionLists)"></el-tab-pane>
          <el-tab-pane label="预扣实缴差异" name="预扣实缴差异" v-if="checkPermission(['incomeDtl_wapd'], permissionLists)"></el-tab-pane>
          <el-tab-pane label="个税申报设置" name="个税申报设置" v-if="checkPermission(['incomeDtl_taxApplySet'], permissionLists)"></el-tab-pane>
        </el-tabs>
        <el-tabs v-model="activeName2" @tab-click="changeTab2">
          <el-tab-pane label="项目" name="0"></el-tab-pane>
          <el-tab-pane label="全部人员" name="1"></el-tab-pane>
          <el-tab-pane label="报税人员" name="4"></el-tab-pane>
          <el-tab-pane label="零申报人员" name="2"></el-tab-pane>
          <el-tab-pane label="错误信息提示" name="3"></el-tab-pane>
        </el-tabs>
        <div class="ftabBtn flex">
          <el-button type="success" size="small" @click="importForm" v-if="checkPermission(['incomeDtl_importZero'], permissionLists) && activeName2!='4'">{{ activeName2=='2' ? '导入零申报数据' : '导入人员所得'}}</el-button>
          <el-button type="warning" size="small" @click="exportList">导出</el-button>
          <div class="payTips" style="margin-left:50px" v-if="activeName2=='0'">注： 税款所属期=申报月-1。</div>
          <div class="payTips" style="margin-left:50px" v-if="activeName2=='2'">注：零申报数据自动生成规则：上月无发薪（包括上月零申报人员），且系统目前在职或上月/本月离职人员。</div>
        </div>

        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%">
          <el-table-column prop="reportingMonth" label="税款所属期" min-width="100" :show-overflow-tooltip="true" align="center" fixed="left">
            <template slot-scope={row}>{{row.reportingMonth!=undefined && row.reportingMonth ? row.reportingMonth.substring(0,7) : ''}}</template>
          </el-table-column>
          <div v-if="activeName2=='0'">
            <el-table-column prop="projectName" label="项目" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="payrollPaymentCount" label="所属期发薪人员" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="zeroCount" label="零申报人员" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="annualTotal" label="发放奖金人数" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="beOnTheJobCount" label="所属期在职人数" min-width="150" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="untreatedJobCount" label="所属期离职人数" min-width="150" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="customerServiceName" label="客服" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="serviceDepartmentName" label="服务部门" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
          </div>
          <div v-if="activeName2=='1' || activeName2=='2' || activeName2=='4'">
            <el-table-column prop="payRollCompany" label="申报公司" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="customerName" label="客户名称" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="subject" label="商务合同主体" v-if="activeName2=='4'" width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="payrollNum" label="发薪编号" v-if="activeName2=='4'" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="projectName" label="项目名称" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="employeeName" label="姓名" min-width="80" :show-overflow-tooltip="true" align="center" fixed="left">
            </el-table-column>
            <el-table-column prop="cardType" label="证件类型" min-width="120" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>{{row.cardType!=undefined && row.cardType ? getCardType(row.cardType) : ''}}</template>
            </el-table-column>
            <el-table-column prop="cardId" label="证件号码" min-width="160" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="phoneNum" label="手机号码" min-width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="nationality" label="国籍" min-width="80" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="typeOfEmployment" label="任职受雇从业类型" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="dateOfEmployment" label="任职受雇从业日期" min-width="140" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>{{ row.dateOfEmployment ? row.dateOfEmployment.split('T')[0] : ''}}</template>
            </el-table-column>
            <el-table-column prop="incomeType" label="所得类型" min-width="100" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>{{ row.incomeType ? row.incomeType=='01' ? '正常工资薪金' : row.incomeType=='02' ? '全年一次性奖金': row.incomeType=='04' ? '劳务报酬': row.incomeType : ''}}</template>
            </el-table-column>
            <el-table-column prop="currentIncome" label="本期收入" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="currentExemptIncome" label="本期免税收入" min-width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="withholdPersonalIncomeTax" label="预扣个税" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="actuallyPersonalIncomeTax" label="实缴个税" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="source" label="来源" min-width="100" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>{{ row.source == 0 ? '系统发薪' : '线下发薪导入'}}</template>
            </el-table-column>
            <el-table-column prop="customerServiceName" label="客服" min-width="80" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="departmentName" label="服务部门" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="personalSupport" label="基本养老保险费" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="personalCare" label="基本医疗保险费" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="personalUnemployment" label="失业保险费" min-width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="providentFundCosts" label="住房公积金" min-width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="cumulativeChildEducation" label="累计子女教育" min-width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="cumulativeContinuingEducation" label="累计继续教育" min-width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="accumulatedHousingLoanInterest" label="累计住房贷款利息" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="accumulatedHousingRent" label="累计住房租金" min-width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="supportTheElderlyCumulatively" label="累计赡养老人" min-width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="cumulativeInfantCareCosts" label="累计3岁以下婴幼儿照护" min-width="160" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="accumulatedPersonalPension" label="累计个人养老金" min-width="130" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="enterpriseOccupationalAnnuity" label="企业(职业)年金" min-width="130" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="commercialHealthInsurance" label="商业健康保险" min-width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="taxDeferredPensionInsurance" label="税延养老保险" min-width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="other" label="其他" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="theAmountOfDonationsAllowedForDeduction" label="准予扣除的捐赠额" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="taxRelief" label="减免税额" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="remark" label="备注" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <!-- <el-table-column prop="submissionConfirmationTime" label="提交确认时间" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column> -->
            <el-table-column prop="personnelCheckStatus" label="校验状态" min-width="100" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>{{row.personnelCheckStatus == 1 ? '未校验' : row.personnelCheckStatus == 2 ? '校验中'  :row.personnelCheckStatus == 3 ? '失败': '成功'}}</template>
            </el-table-column>
            <el-table-column prop="calculateTaxStatus" label="算税状态" min-width="100" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>{{row.calculateTaxStatus == 1 ? '成功' : row.calculateTaxStatus == 2 ? '未算税' :'失败'}}</template>
            </el-table-column>
            <el-table-column prop="taxReturnAttachment" label="报税附件" min-width="100" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>
                <div class="injuryTabBtn">
                  <el-button type="text" v-if="row.taxReturnAttachment" @click="down(row.taxReturnAttachment)">下载</el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="zeroDeclarationReason" label="零申报原因" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
          </div>
          <div v-if="activeName2=='3'">
            <el-table-column prop="reportingMonth" label="薪资归属月" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="payRollCompanyName" label="申报公司" min-width="150" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="errorMsg" label="错误信息" min-width="200" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="customerName" label="客户名称" min-width="150" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="projectName" label="项目名称" min-width="150" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="employeeNames" label="姓名" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="cardType" label="证件类型" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="cardId" label="证件号码" min-width="155" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="phoneNum" label="手机号码" min-width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="typeOfEmployment" label="任职受雇从业类型" min-width="150" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="dateOfEmployment" label="任职受雇从业日期" min-width="150" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="customerServiceName" label="客服" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="remark" label="备注" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
          </div>
          <el-table-column label="操作" min-width="210" :show-overflow-tooltip="true" align="center" fixed="right">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <!-- <el-button type="text" v-if="activeName2=='0'">查看</el-button> -->
                <el-button type="text" v-if="(activeName2=='1' || activeName2=='2') && checkPermission(['incomeDtl_edit'], permissionLists)" @click="editInfo(row,'allEdit')">编辑</el-button>
                <el-button type="text" v-if="activeName2=='3' && checkPermission(['incomeDtl_edit'], permissionLists)" @click="editInfo(row,'errEdit')">修改</el-button>
                <el-button type="text" @click="importDataPro(row)" v-if="activeName2=='0' && checkPermission(['incomeDtl_importZero'], permissionLists)">导入人员所得</el-button>
                <el-popconfirm title="请确定是否删除？" style="margin-left: 10px;" @confirm="del(row)" v-if="activeName2!='3' && checkPermission(['incomeDtl_del'], permissionLists)">
                  <el-button type="text" slot="reference">{{activeName2=='0' ? '人员所得整批删除' : '删除'}}</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.PageModel.Page" :page-size="Number(listQuery.PageModel.Rows)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="编辑" :visible.sync="showEditInfo" width="600px">
      <el-form :model="editForm" ref="editForm" label-width="110px">
        <el-form-item label="姓名" prop="employeeName">
          <el-input v-model="editForm.employeeName" size="small" style="width:300px" clearable :disabled="info.source==0 || info.source==1"></el-input>
        </el-form-item>
        <el-form-item label="证件类型" prop="cardType">
          <el-select v-model="editForm.cardType" placeholder="" size="small" style="width: 300px;" clearable filterable>
            <el-option v-for="(item,index) in cardTypeList" :key="index" :label="item.name" :value="item.val"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="证件号码" prop="cardId">
          <el-input v-model="editForm.cardId" size="small" style="width:300px" disabled readonly></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="phoneNum">
          <el-input v-model="editForm.phoneNum" type="number" size="small" style="width:300px" clearable></el-input>
        </el-form-item>
        <el-form-item label="所得类型" prop="incomeType">
          <el-select v-model="editForm.incomeType" placeholder="" size="small" style="width: 300px;" clearable filterable>
            <el-option label="正常工资薪金" value="01"></el-option>
            <el-option label="全年一次性奖金（一次扣税）" value="02"></el-option>
            <el-option label="劳务报酬" value="04"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所得金额" prop="currentIncome" v-if="activeName2=='1'">
          <el-input v-model="editForm.currentIncome" type="number" size="small" style="width:300px" clearable :disabled="info.source==0 || info.source==1"></el-input>
        </el-form-item>
        <el-form-item label="税款所属期" prop="applyMonth">
          <el-date-picker v-model="editForm.applyMonth" type="month" value-format="yyyy-MM" size="small" style="width: 300px;">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEditInfo = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmEdit" :loading="isBtnLoading">确 认</el-button>
      </span>

    </el-dialog>

    <el-dialog :title="activeName2=='0' ? '导入人员所得' : activeName2=='2' ? '导入零申报数据' : '导入数据'" :visible.sync="showImport" width="550px">
      <el-form :model="formData" ref="formImport" :rules="rules" label-width="110px">
        <el-form-item label="发薪项目">
          <el-select v-model="Project" placeholder="" value-key="Projectid" size="small" style="width: 300px;" clearable filterable @change="changePro">
            <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所得类型" prop="incomeType">
          <el-select v-model="formData.incomeType" placeholder="" size="small" style="width: 300px;" clearable filterable>
            <el-option value="正常工资薪金"></el-option>
            <el-option value="劳务报酬"></el-option>
            <el-option value="全年一次性奖金（一次扣税）"></el-option>
            <el-option value="全年多次性奖金（多次发放）"></el-option>
            <el-option value="解除劳动合同一次性补偿"></el-option>
            <el-option value="个税差额补发"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="归属月" prop="reportingMonth">
          <el-date-picker v-model="formData.reportingMonth" type="month" value-format="yyyy-MM" size="small" style="width: 300px;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="税款所属期" prop="applyMonth">
          <el-date-picker v-model="formData.applyMonth" type="month" value-format="yyyy-MM" size="small" style="width: 300px;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="导入模板">
          <el-button type="text" @click="downTemp" :disabled="!formData.incomeType">下载模板</el-button>
        </el-form-item>
        <el-form-item :label="activeName2=='0' ? '导入人员所得' : activeName2=='2' ? '导入零申报数据' : '导入数据'" prop="Url">
          <div style="width:300px">
            <el-upload class="upload-demo" action="" :on-remove="handleRemove1" multiple :limit="1" :auto-upload="false" :on-exceed="handleExceed1" :on-change="handleUploadPSR" accept=".xlsx,.xls" :file-list="fileListPSR" :disabled="!formData.incomeType">
              <el-button size="small" type="primary" :disabled="!formData.incomeType">点击上传</el-button>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showImport = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmSubmit" :loading="isBtnLoading">确 认</el-button>
      </span>

    </el-dialog>
    <el-dialog :visible.sync="showAllSign" width="500px" :close-on-press-escape="false" :show-close="false">
      <div v-if="!checkOver">
        <div class="Checking">
          <video loading="lazy" muted="muted" src="../../assets/images/loadingCoffe.mp4" type="video/mp4" autoplay="autoplay" loop="loop" style="width:100px;height:auto;object-fit:fill;mix-blend-mode: darken;"></video>
        </div>
        <div class="CheckingTips">
          人员校验进行中，预计耗时1~3分钟，请耐心等待......
        </div>
        <!-- <div class="footer">
          <el-button type="danger" size="small" @click="StopCheck" :loading="isloading">终止校验</el-button>
        </div> -->
      </div>
      <div v-if="checkOver">
        人员校验结束，其中
        <span class="num1 success"> {{checkSuccess}} </span>
        人校验成功，<span class="num1 red"> {{checkFailed}} </span>人校验失败
      </div>
      <span slot="footer" class="dialog-footer" v-if="checkOver">
        <el-button size="small" @click="showAllSign = false">关 闭</el-button>
        <el-button size="small" type="primary" v-if="type=='import'" @click="continueGetTax">继续算税</el-button>
        <el-button size="small" type="primary" v-if="type=='allEdit'" @click="continueGetTax2">继续算税</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="showAllTax" width="500px" :close-on-press-escape="false" :show-close="false">
      <div v-if="!taxOver">
        <div class="Checking">
          <video loading="lazy" muted="muted" src="../../assets/images/loadingCoffe.mp4" type="video/mp4" autoplay="autoplay" loop="loop" style="width:100px;height:auto;object-fit:fill;mix-blend-mode: darken;"></video>
        </div>
        <div class="CheckingTips">算税进行中，预计耗时1~5分钟，请耐心等待.....</div>
        <!-- <div class="footer">
          <el-button type="danger" size="small" @click="StopTax" :loading="isloading">终止算税</el-button>
        </div> -->
      </div>
      <div v-if="taxOver">
        算税结束，其中
        <span class="num1 success"> {{taxSuccess}} </span>
        人算税成功，<span class="num1 red"> {{taxFailed}} </span>
        人失败
      </div>
      <span slot="footer" class="dialog-footer" v-if="taxOver">
        <el-button size="small" @click="showAllTax = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog title="错误信息" :visible.sync="showError" width="500px" :close-on-press-escape="false">
      <el-table :data="errorInfo" style="width:100%">
        <el-table-column prop="name" label="姓名" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="errorMsg" label="错误信息" min-width="340" :show-overflow-tooltip="true" align="center">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="showError = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import moment from 'moment';
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        listQuery: {
          cardId: '',
          name2: '',
          ReportingMonth: moment().subtract(1, 'months').format('YYYY-MM'), //税款所属期
          PayrollCompany: '', //公司
          Subject: '', //主体
          projectId: null,
          CustomerServiceId: '', //客服id
          EmployeeName: '', //姓名
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
          PageModel: {
            Rows: 10,
            Page: 1,
            OrderInput: [{
              property: "year",
              order: 1
            }, {
              property: "month",
              order: 1
            }]
          }
        },
        showDropScreen: -1,
        tableData: [],
        roletype: localStorage.loginRoletype,
        multipleSelection: [],
        totalCount: 0,
        activeName2: '0',
        activeName: '所得明细',
        loading: false,
        legList: [],
        showImport: false,
        proNameList: [],
        headPath: this.$store.state.EMP.tablePath,
        Subject: '',
        formData: {
          reportingMonth: moment().subtract(1, 'months').format('YYYY-MM-DD'),
          incomeType: '',
          applyMonth: moment().format('YYYY-MM-DD'),
          projectId: null,
          projectName: '',
          fileUrl: '',
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
          isProjectImport: true
        },
        rules: {
          projectId: {
            required: true,
            message: '请选择发薪项目',
            trigger: 'change'
          },
          applyMonth: {
            required: true,
            message: '请选择申报月',
            trigger: 'change'
          },
          incomeType: {
            required: true,
            message: '请选择所得类型',
            trigger: 'change'
          },
          reportingMonth: {
            required: true,
            message: '请选择归属月',
            trigger: 'change'
          },
          fileUrl: {
            required: true,
            message: '请上传薪资表',
            trigger: 'change'
          },
        },
        fileListPSR: [],
        Project: '',
        isBtnLoading: false,
        interval: null,
        showAllSign: false, //校验弹窗
        listid: [], //要查询的listid
        checkSuccess: 0, //校验成功人数
        checkOver: false, //校验是否完成
        checkFailed: 0, //校验失败人数
        checkTotal: 0, //校验全部人数
        taxSuccess: 0, //算税成功人数
        taxOver: 0, //算税是否完成
        taxFailed: 0, //算税失败人数
        taxTotal: 0, //算税成功人数
        intervalNum: 0,
        showAllTax: false,
        errorInfo: [],
        showError: false,
        Id: '',
        showEditInfo: false,
        cardTypeList: this.$store.state.EMP.cardType,
        editForm: {
          id: '',
          applyMonth: '', //申报月
          incomeType: '', //所得类型
          currentIncome: 0, //本期收入
          employeeName: '',
          cardType: '', //证件类型
          cardId: '', //证件号码
          phoneNum: '',
          updataUserId: Cookies.get("userid-b"),
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype
        },
        info: {},
        roleName: localStorage.roleName,
        permissionLists: [],
        customerList: [], //客服列表
        editRules: {
          employeeName: {
            required: true,
            message: '请输入',
            trigger: 'blur'
          },
          cardType: {
            required: true,
            message: '请选择证件类型',
            trigger: 'change'
          },
          cardId: {
            required: true,
            message: '请输入证件号码',
            trigger: 'blur'
          },
          phoneNum: {
            required: true,
            message: '请输入手机号码',
            trigger: 'blur'
          },
          incomeType: {
            required: true,
            message: '请选择所的类型',
            trigger: 'change'
          },
          applyMonth: {
            required: true,
            message: '请选择申报月',
            trigger: 'change'
          }
        },
        type: '',
      }
    },
    created() {
      this.getButtonPower();
      this.getlegalsubjectlist();
      this.GetIncomePageList();
      this.getProList();
      this.getMemberList();
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let that = this
        let butQuery = {
          path: '/incomeDtl',
          powerEnName: 'sarary'
        }
        xz.getbtnPowerIdBypage(butQuery).then(res => {
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                that.permissionLists.push(element.Enname);
              }
              // console.log(that.permissionLists)
            } else {
              this.permissionLists = []
            }
          } else {
            this.$message.error('获取按钮权限出错')
            this.permissionLists = []
          }
        })
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let d = {
          userid: Cookies.get("userid-b"),
          companyName: '',
          isCanInsure: false,
          pageNum: 1,
          pageSize: 1000
        }
        xz.ArdCurStat(d, 'GetUserLegalList').then(res => {
          if (res.status == 'ok') {
            this.legList = res.data.date;
          } else {
            this.legList = [];
          }
        })
      },
      // 获取客服列表
      getMemberList(type) {
        let data = {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "",
          strstation: "",
          strorgancode: "",
        }
        xz.getauthUserInfoByorgancode(data).then((res) => {
          if (res.status == "ok") {
            this.customerList = res.msg;
          } else {
            this.customerList = [];
          }
        });
      },
      isNull(o) {
        // console.log('isnull',o)
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == "NaN" ||
          o == '[{}]'
        );
      },
      currentChange(val) {
        this.listQuery.PageModel.Page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.PageModel.Page = 1;
        this.listQuery.PageModel.Rows = val;
        this.getList();
      },
      searchHandle() {
        this.listQuery.PageModel.Page = 1;
        this.getList();
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      //查询所得明细列表  项目
      GetIncomePageList() {
        this.loading = true;
        xz.GetIncomePageList(this.listQuery, this.roletype).then(res => {
          try {
            this.tableData = res.data.data;
            this.totalCount = Number(res.data.pageModel.totalCount);
            this.loading = false;
          } catch (e) {
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
            this.$message.error('获取列表失败')
          }
        })
      },
      //全部人员列表/零申报人员列表
      GetIncomePersonPageList() {
        this.loading = true;
        xz.GetIncomePersonPageList(this.listQuery, this.roletype).then(res => {
          try {
            this.tableData = res.data.data;
            this.totalCount = res.data.pageModel.totalCount;
            this.loading = false;
          } catch (e) {
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
            this.$message.error('获取列表失败')
          }
        })
      },
      //获取错误信息
      GetErrorMsgPageList() {
        this.loading = true;
        xz.GetErrorMsgPageList(this.listQuery, this.roletype).then(res => {
          try {
            this.tableData = res.data.data;
            this.totalCount = res.data.pageModel.totalCount;
            this.loading = false;
          } catch (e) {
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
            this.$message.error('获取列表失败')
          }
        })
      },
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      changePro(val) {
        this.formData.projectId = val.Projectid;
        this.formData.projectName = val.StrprojectName;
        console.log(val, this.formData.projectId)
        xz.getProjectDetailversion1(val.Projectid).then(res => {
          if (res.msgsub.length > 0) {
            this.Subject = res.msgsub[0].StrSignsubjectName;
          } else {
            this.Subject = '';
          }
        })
      },
      changeTab(tab) {
        if (tab.index == '7' || tab.index == '8') {
          this.$router.push({
            path: '/deductionInfo'
          })
        } else if (tab.index == '9') {
          this.$router.push({
            path: '/taxApplySet'
          })
        } else if (tab.index == '1') {
          this.$router.push({
            path: '/incomeDtl'
          })
        } else {
          this.$router.push({
            path: '/tax',
            query: {
              activeName: this.activeName
            }
          })
        }
      },
      getList() {
        if (this.activeName2 == '0') {
          this.GetIncomePageList();
        } else if (this.activeName2 == '1' || this.activeName2 == '2' || this.activeName2 == '4') {
          this.GetIncomePersonPageList();
        } else {
          this.GetErrorMsgPageList();
        }
      },
      changeTab2() {
        if (this.activeName2 == '0') {
          this.listQuery = {
            ReportingMonth: '', //申报月/税款所属期
            PayrollCompany: this.listQuery.PayrollCompany, //公司
            Subject: '', //主体
            projectId: this.listQuery.projectId,
            CustomerServiceId: '', //客服id
            EmployeeName: '', //姓名
            userId: Cookies.get("userid-b"),
            roleType: localStorage.loginRoletype,
            PageModel: {
              Rows: 10,
              Page: 1,
              OrderInput: [{
                property: "year",
                order: 1
              }, {
                property: "month",
                order: 1
              }]
            }
          }
          this.GetIncomePageList();
        } else if (this.activeName2 == '1' || this.activeName2 == '2' || this.activeName2 == '4') {
          this.listQuery = {
            ReportingMonth: this.listQuery.ReportingMonth, //申报月/税款所属期
            PayrollCompany: this.listQuery.PayrollCompany, //公司
            Subject: '', //主体
            projectId: this.listQuery.projectId,
            CustomerServiceId: '', //客服id
            EmployeeName: '', //姓名
            userId: Cookies.get("userid-b"),
            roleType: localStorage.loginRoletype,
            PageModel: {
              Rows: 10,
              Page: 1,
              OrderInput: [{
                property: "CreateTime",
                order: 1
              }]
            }
          }
          if (this.activeName2 == '2') {
            this.listQuery['isZeroDeclaration'] = true
          } else if (this.activeName2 == '4') {
            this.listQuery['isZeroDeclaration'] = false
          }
          this.GetIncomePersonPageList();
        } else if (this.activeName2 == '3') {
          this.listQuery = {
            ReportingMonth: '', //申报月/税款所属期
            customerName: '',
            customerServiceId: '',
            EmployeeName: '', //姓名
            projectName: '',
            phoneNum: '',
            cardId: '',
            employeeNames: '',
            userId: Cookies.get("userid-b"),
            roleType: localStorage.loginRoletype,
            PageModel: {
              Rows: 10,
              Page: 1,
              OrderInput: []
            }
          }
          this.GetErrorMsgPageList();
        }
      },
      //导入
      importDataPro(row) {
        this.formData = {
          reportingMonth: moment().subtract(1, 'months').format('YYYY-MM-DD'),
          incomeType: '',
          applyMonth: moment().format('YYYY-MM-DD'),
          projectId: Number(row.projectId),
          projectName: row.projectName,
          fileUrl: '',
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
          isProjectImport: true
        }
        this.fileListPSR = [];
        this.showImport = true;
      },
      //删除  项目/人员
      del(row) {
        if (this.activeName2 == '0') {
          let data = {
            ProjectId: [Number(row.projectId)],
            ApplyMonth: moment(row.reportingMonth).format('YYYY-MM-DD'), //申报月
          }
          this.loading = true;
          xz.DeleteIsZeroInComeDetail(data, this.roletype).then(res => {
            try {
              if (res.status == 'ok') {
                this.$message.success('删除成功！')
                this.loading = false;
                this.getList();
              } else {
                this.loading = false;
                this.$message.error(res.msg)
              }
            } catch (e) {
              this.$message.error('系统出错')
              this.loading = false;
            }
          })
        } else {
          let data = {
            id: [row.id],
            ApplyMonth: moment(row.reportingMonth).format('YYYY-MM-DD'), //申报月
          }
          this.loading = true;
          xz.DeleteInComeDetail(data, this.roletype).then(res => {
            try {
              if (res.status == 'ok') {
                this.$message.success('删除成功！')
                this.loading = false;
                this.getList();
              } else {
                this.$message.error(res.msg)
                this.loading = false;
              }
            } catch (e) {
              this.$message.error('系统出错')
              this.loading = false;
            }
          })
        }
      },
      exportList() {
        if (this.activeName2 == '0') {
          let data = {
            reportingMonth: this.listQuery.ReportingMonth,
            subject: this.listQuery.Subject,
            PayrollCompany: this.listQuery.PayrollCompany,
            employeeName: this.listQuery.EmployeeName,
            cardId: this.listQuery.CardId,
            phoneNum: this.listQuery.PhoneNum,
            customerServiceId: this.listQuery.CustomerServiceId,
            departmentId: this.listQuery.DepartmentId,
            projectId: this.listQuery.projectId,
            occurrenceStartTime: null,
            occurrenceEndTime: null,
            userId: Cookies.get("userid-b"),
            roleType: localStorage.loginRoletype,
          }
          if (this.activeName2 == '2') {
            data['isZeroDeclaration'] = true
          }
          xz.ExportInComeDetail(data).then(res => {
            try {
              var data = new Blob([res], {
                type: "application/vnd.ms-excel;charset=utf-8"
              });
              var downloadUrl = window.URL.createObjectURL(data);
              var anchor = document.createElement("a");
              anchor.href = downloadUrl;
              anchor.download = '所得明细列表' + ".xlsx";
              anchor.click();
              window.URL.revokeObjectURL(data);
            } catch (e) {

            }
          })
        } else if (this.activeName2 == '1' || this.activeName2 == '2' || this.activeName2 == '4') {
          let data = {
            reportingMonth: this.listQuery.ReportingMonth,
            subject: this.listQuery.Subject,
            PayrollCompany: this.listQuery.PayrollCompany,
            employeeName: this.listQuery.EmployeeName,
            cardId: this.listQuery.CardId,
            phoneNum: this.listQuery.PhoneNum,
            customerServiceId: this.listQuery.CustomerServiceId,
            departmentId: this.listQuery.DepartmentId,
            projectId: this.listQuery.projectId,
            occurrenceStartTime: null,
            occurrenceEndTime: null,
            // isZeroDeclaration: false,
            userId: Cookies.get("userid-b"),
            roleType: localStorage.loginRoletype,
          }
          if (this.activeName2 == '2') {
            data['isZeroDeclaration'] = true
          } else if (this.activeName2 == '4') {
            data['isZeroDeclaration'] = false
          }
          xz.ExportInComePersonalDetail(data).then(res => {
            try {
              var data = new Blob([res], {
                type: "application/vnd.ms-excel;charset=utf-8"
              });
              var downloadUrl = window.URL.createObjectURL(data);
              var anchor = document.createElement("a");
              anchor.href = downloadUrl;
              anchor.download = '列表导出' + ".xlsx";
              anchor.click();
              window.URL.revokeObjectURL(data);
            } catch (e) {

            }
          })
        }
      },
      //导入
      importForm() {
        this.Project = '';
        this.formData = {
          reportingMonth: moment().subtract(1, 'months').format('YYYY-MM-DD'),
          incomeType: '',
          applyMonth: moment().format('YYYY-MM-DD'),
          projectId: null,
          projectName: '',
          fileUrl: '',
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
          isProjectImport: true
        }
        this.fileListPSR = [];
        this.showImport = true;
        this.type = 'import';
      },
      handleUploadPSR(file) {
        const formData = new FormData();
        formData.append("pagename", "empexcel");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.formData.fileUrl = res;
            this.fileListPSR.push({
              name: file.name,
              url: res,
            });
          } else {
            this.formData.fileUrl = ''
          }
        });
      },
      handleRemove1() {
        this.formData.fileUrl = '';
        this.fileListPSR = [];
      },
      handleExceed1() {
        this.$message.warning(`最多上传 1 个文件，请先删除再上传`);
      },
      downTemp() {
        let path;
        if (this.formData.incomeType == '全年一次性奖金（一次扣税）') {
          path = this.headPath + 'excel/caa39434-539c-40cb-95d6-31b215f0f9dc/E20250714103157712.xls';
        } else {
          path = this.headPath + "excel/024dc6c2-99e3-41f6-b847-438a2d2795fd/E20250714102559577.xlsx";
        }
        const aTag = document.createElement('a')
        aTag.href = path
        aTag.click();
      },
      confirmSubmit() {
        this.isBtnLoading = true;
        xz.ImportInComeDetail(this.formData).then(res => {
          try {
            if (res.status == 'ok') {
              if (res.data.failCount > 0) {
                this.errorInfo = res.data.error;
                this.showError = true;
                this.isBtnLoading = false;
              } else if (res.data.applySalaryId) {
                this.isBtnLoading = false;
                this.getList();
                this.showImport = false;
                this.$message.success('导入成功！')
                // this.Id = res.data.applySalaryId;
                // this.taxCalc(res.data.applySalaryId);
              } else {
                this.$message.error('返回applySalaryId为空')
              }
            } else {
              this.$message.error(res.msg)
              this.isBtnLoading = false;
              this.getList();
            }
          } catch (e) {
            console.log(e)
            this.$message.error('系统出错')
            this.isBtnLoading = false;
            this.getList();
          }
        })
      },
      //校验
      taxCalc(id) {
        var arrids = [];
        arrids.push(id);
        this.showAllSign = true;
        this.checkOver = false;
        console.log('taxCalc')
        // let data = {
        //   issend: "true",
        //   entname: this.Subject,
        //   datestr: this.formData.applyMonth,
        //   userid: Cookies.get("userid-b"),
        //   id
        // }
        let data = {
          issend: "true",
          entname: this.Subject,
          datestr: this.formData.applyMonth,
          userid: Cookies.get("userid-b"),
          ids: arrids
        }
        // xz.senduseralltoxft(data).then(res => {
        //   if (res.status == 'ok') {
        //     clearInterval(this.interval);
        //     setTimeout(() => {
        //       this.getAllStatus();
        //     }, 3000);
        //     this.intervalNum = 0;
        //     this.interval = setInterval(this.Refresh3, 10000)
        //   } else {
        //     this.showAllSign = false;
        //     this.checkOver = true;
        //     this.$message.error(res.msg)
        //   }
        // })xyy临时改动

        xz.sendUserALLToXFTDeclartion(data).then(res => {
          if (res.status == 'ok') {
            clearInterval(this.interval);
            setTimeout(() => {
              this.getAllStatus1();
            }, 3000);
            this.intervalNum = 0;
            this.interval = setInterval(this.Refresh3, 10000)
          } else {
            this.showAllSign = false;
            this.checkOver = true;
            this.$message.error(res.msg)
          }
        }) //xyy临时改动
      },
      //获取校验状态值
      getAllStatus1() {
        // let data = {
        //   pageNum: 1,
        //   pageSize: 10,
        //   id: this.Id,
        //   ids: '',
        //   CardId: '',
        //   PersonnelCheck: '',
        //   EmployeeName: '',
        //   BankAccount: '',
        //   checkState: '', //校验状态
        //   taxState: '', //算税状态
        // }
        // xz.getApplicationPayrollDetail(data, this.roletype).then(res => {
        //   if (res.status == 'ok') {
        //     if (this.showAllSign && res.data.checkState == '校验完成' && res.data.checkState != '终止校验') {
        //       this.checkSuccess = res.data.checkSuccess;
        //       this.checkFailed = res.data.checkFail;
        //       this.checkOver = true;
        //       clearInterval(this.interval);
        //       if (this.type == 'import') {
        //         xz.SetPersonnelCheck({
        //           applySalaryId: this.Id //临时改动
        //         }).then(res => {})
        //       } else if (this.type == 'allEdit') {
        //         xz.SetAllPersonnelOrZeroCheck({
        //           applySalaryId: this.info.applySalaryId
        //         }).then(res => {
        //           this.confirmEdit();
        //         })
        //       }
        //     } else if (this.showAllTax && res.data.taxState == '算税完成' && res.data.taxState != '终止算税') {
        //       this.taxSuccess = res.data.taxSuccess;
        //       this.taxFailed = res.data.taxFail;
        //       // this.taxNo = res.data.taxNo;
        //       this.taxOver = true;
        //       clearInterval(this.interval);
        //       if (this.type == 'import') {
        //         xz.SetCalculateTax({
        //           applySalaryId: this.Id
        //         }).then(res => {
        //           this.showImport = false;
        //         })
        //       } else if (this.type == 'allEdit') {
        //         xz.SetAllPersonalOrZeroCalculateTax({
        //           applySalaryId: this.Id
        //         }).then(res => {})
        //       }
        //     }
        //   }
        // })
        let data = {
          applySalaryId: [this.Id],
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype
        }
        xz.PullInComeStatus(data).then(res => {
          try {
            if (res.status == 'ok') {
              this.checkSuccess = res.data.success;
              this.checkOver = res.data.over;
              this.checkFailed = res.data.failed;
              this.checkTotal = res.data.total;
              if (res.data.over) {
                clearInterval(this.interval);
                if (this.type == 'import') {
                  xz.SetPersonnelCheck({
                    applySalaryId: this.Id //临时改动
                  }).then(res => {})
                } else if (this.type == 'allEdit') {
                  xz.SetAllPersonnelOrZeroCheck({
                    applySalaryId: this.info.applySalaryId
                  }).then(res => {
                    this.confirmEdit();
                  })
                }
              }
            } else {
              this.$message.error(res.msg);
              clearInterval(this.interval);
              this.showAllSign = false;
            }
          } catch (e) {
            clearInterval(this.interval);
          }
        })
      },
      //获取算税状态值
      getAllStatus2() {
        let data = {
          applySalaryId: [this.Id],
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype
        }
        xz.PullInComeTaxCacuStatus(data).then(res => {
          try {
            if (res.status == 'ok') {
              this.taxSuccess = res.data.success;
              this.taxOver = res.data.over;
              this.taxFailed = res.data.failed;
              this.taxTotal = res.data.total;
              if (res.data.over) {
                clearInterval(this.interval);
                this.showAllSign = false;
                this.showAllTax = false;
                if (this.type == 'import') {
                  xz.SetCalculateTax({
                    applySalaryId: this.Id
                  }).then(res => {
                    this.showImport = false;
                  })
                } else if (this.type == 'allEdit') {
                  xz.SetAllPersonalOrZeroCalculateTax({
                    applySalaryId: this.Id
                  }).then(res => {})
                }
              }
            } else {
              this.$message.error(res.msg);
              clearInterval(this.interval);
              this.showAllSign = false;
            }
          } catch (e) {}
        })
      },
      //继续算税
      continueGetTax() {
        this.showAllSign = false;
        this.taxOver = false;
        this.showAllTax = true;
        this.listQuery.ids = '';
        // let data2 = {
        //   userid: Cookies.get("userid-b"),
        //   entname: this.Subject,
        //   objectid: this.formData.projectId,
        //   datestr: this.formData.applyMonth,
        //   cacucode: '',
        //   id: this.Id
        // }
        let data2 = {
          userid: Cookies.get("userid-b"),
          entname: this.Subject,
          objectid: this.formData.projectId,
          datestr: this.formData.applyMonth,
          cacucode: [],
          ids: [this.Id]
        }
        // xz.senduserlisttax(data2).then(res => {
        //   if (res.status == 'ok') {
        //     clearInterval(this.interval);
        //     setTimeout(() => {
        //       this.getAllStatus();
        //     }, 3000);
        //     this.intervalNum = 0;
        //     this.interval = setInterval(this.Refresh3, 10000);
        //   } else {
        //     this.$message.error(res.msg);
        //     this.showAllTax = false;
        //     this.taxOver = true;
        //   }
        // })xyy临时改动

        xz.sendUserListTaxDeclartion(data2).then(res => {
          if (res.status == 'ok') {
            clearInterval(this.interval);
            setTimeout(() => {
              this.getAllStatus2();
            }, 3000);
            this.intervalNum = 0;
            this.interval = setInterval(this.Refresh4, 10000);
          } else {
            this.$message.error(res.msg);
            this.showAllTax = false;
            this.taxOver = true;
          }
        }) //xyy临时改动
      },
      //刷新状态
      Refresh3() {
        this.intervalNum++;
        this.getAllStatus1();
        console.log('intervalNum', this.intervalNum)
        if (this.intervalNum == 360) {
          this.intervalNum = 0;
          clearInterval(this.interval);
          this.showAllSign = false;
          this.showAllTax = false;
          this.$message.warning('查询超时！')
        }
      },
      //刷新状态
      Refresh4() {
        this.intervalNum++;
        this.getAllStatus2();
        console.log('intervalNum', this.intervalNum)
        if (this.intervalNum == 360) {
          this.intervalNum = 0;
          clearInterval(this.interval);
          this.showAllSign = false;
          this.showAllTax = false;
          this.$message.warning('查询超时！')
        }
      },
      //编辑
      editInfo(row, type) {
        this.info = row;
        this.editForm = {
          id: row.id,
          applyMonth: moment(row.applyMonth).format('YYYY-MM-DD'), //申报月
          incomeType: row.incomeType, //所得类型
          currentIncome: row.currentIncome ? row.currentIncome : 0,
          employeeName: row.employeeName,
          cardType: row.cardType, //证件类型
          cardId: row.cardId, //证件号码
          phoneNum: row.phoneNum,
          updataUserId: Cookies.get("userid-b"),
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype
        }
        this.isBtnLoading = false;
        this.showEditInfo = true;
        this.type = type;
      },
      //编辑后发起校验
      initiateTax() {
        let pagename = this.info.source == 0 ? 'StartDeclareCacuTax' : 'StartPersonalCheck';
        let data = {
          applySalaryId: this.listid,
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype
        }
        xz.StartPersonalCheck(data, pagename).then(res => {
          try {
            if (res.status == 'ok') {
              clearInterval(this.interval);
              setTimeout(() => {
                this.getCheckStatus();
              }, 3000);
              this.intervalNum = 0;
              this.interval = setInterval(this.Refresh, 10000)
              this.isBtnLoading = false;
            } else {
              this.$message.error(res.msg);
              this.isBtnLoading = false;
            }
          } catch {
            this.$message.error('系统出错');
            this.isBtnLoading = false;
          }
        })
      },
      getCheckStatus() {
        let data = {
          applySalaryId: this.listid,
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype
        }
        let pagename = this.info.source == 0 ? '/IncomeBatch/PullInComeStatus' : '/IncomeDetail/PullInComeStatusNotDeclare';
        xz.PullInComeStatusNotDeclare(data, pagename).then(res => {
          try {
            if (res.status == 'ok') {
              this.checkSuccess = res.data.success;
              this.checkOver = res.data.over;
              this.checkFailed = res.data.failed;
              this.checkTotal = res.data.total;
              if (res.data.over) {
                clearInterval(this.interval);
              }
            } else {
              this.$message.error(res.msg);
              clearInterval(this.interval);
              this.showAllSign = false;
              this.showEditInfo = false;
            }
          } catch (e) {}
        })
      },
      Refresh() {
        this.intervalNum++;
        this.getCheckStatus();
        console.log('intervalNum', this.intervalNum)
        if (this.intervalNum == 180) {
          this.intervalNum = 0;
          clearInterval(this.interval);
          this.showAllSign = false;
          this.$message.warning('查询超时！')
        }
      },
      //继续算税
      continueGetTax2() {
        this.showAllSign = false;
        this.showAllTax = true;
        this.taxOver = false;
        let data = {
          applySalaryId: this.listid,
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype
        }
        let pagename = this.info.source == 0 ? '/IncomeBatch/CheckCacuTaxInComeDetailBatch' : '/IncomeDetail/CheckCacuTaxInComeDetailNotDeclare';
        xz.CheckCacuTaxInComeDetailNotDeclare(data, pagename).then(res => {
          try {
            if (res.status == 'ok') {
              clearInterval(this.interval);
              setTimeout(() => {
                this.getTaxStatus();
              }, 3000);
              this.intervalNum = 0;
              this.interval = setInterval(this.Refresh2, 10000)
            } else {
              this.$message.error(res.msg);
              this.isBtnLoading = false;
            }
          } catch {
            this.$message.error('系统出错');
            this.isBtnLoading = false;
          }
        })
      },
      //查询算税状态
      getTaxStatus() {
        let data = {
          applySalaryId: this.listid,
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype
        }
        let pagename = this.info.source == 0 ? '/IncomeBatch/PullInComeTaxCacuStatus' : '/IncomeDetail/PullInComeTaxCacuStatusNotDeclare';
        xz.PullInComeTaxCacuStatusNotDeclare(data, pagename).then(res => {
          try {
            if (res.status == 'ok') {
              this.taxSuccess = res.data.success;
              this.taxOver = res.data.over;
              this.taxFailed = res.data.failed;
              this.taxTotal = res.data.total;
              if (res.data.over) {
                clearInterval(this.interval);
              }
            } else {
              this.$message.error(res.msg);
              clearInterval(this.interval);
              this.showAllTax = false;
              this.showEditInfo = false;
            }
          } catch (e) {}
        })
      },
      Refresh2() {
        this.intervalNum++;
        this.getTaxStatus();
        console.log('intervalNum', this.intervalNum)
        if (this.intervalNum == 180) {
          this.intervalNum = 0;
          clearInterval(this.interval);
          this.showAllTax = false;
          this.$message.warning('查询超时！')
        }
      },
      confirmEdit() {
        this.isBtnLoading = true;
        let pagename = this.info.source == 0 ? 'CreateOrEditDeclareDetail' : 'CreateOrEditInComeDetail'
        xz.CreateOrEditInComeDetail(this.editForm, pagename).then(res => {
          try {
            if (res.status == 'ok') {
              this.isBtnLoading = false;
              this.$message.success('保存成功！')
              this.showEditInfo = false;
              if (res.data.length > 0) {
                this.listid = res.data;
                this.isBtnLoading = true;
                this.showAllSign = true;
                this.checkOver = false;
                this.initiateTax();
              }
              // this.showEditInfo = false;
              // this.getList();
            } else {
              this.isBtnLoading = false;
              this.showEditInfo = false;
              this.getList();
              this.$message.error(res.msg)
            }
          } catch (e) {
            this.isBtnLoading = false;
            this.$message.error('系统出错')
          }
        })
      },
      getCardType(val) {
        if (val) {
          let a = '';
          try {
            this.cardTypeList.forEach(element => {
              if (val == element.val) {
                a = element.name
                throw Error(`We've found the target element.`)
              }
            });
          } catch (e) {}
          return a
        } else {
          return '333'
        }
      },
      //下载
      down(url) {
        const aTag = document.createElement('a')
        aTag.href = url
        aTag.click();
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .red {
    color: red;
  }

  .success {
    color: #19BD92;
  }

  .Checking {
    display: flex;
    justify-content: center;
  }

  .CheckingTips {
    text-align: center;
    margin-top: 15px;
    font-size: 14px;
  }

  .footer {
    display: flex;
    justify-content: center;
    margin-top: 15px;
  }

  .payTips {
    color: red;
    padding-left: 20px;
    font-size: 14px;
  }
</style>
<style>
  .page_tax .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_tax .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_tax .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_tax .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_tax .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_tax .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_tax #tab-所得明细 {
    background: #FFFF00;
  }

  .page_tax #tab-待确认 {
    background: #FFFF00;
  }
</style>